import { render, staticRenderFns } from "./PrintSectionVoidsOnly.vue?vue&type=template&id=520e6c68&"
import script from "./PrintSectionVoidsOnly.vue?vue&type=script&lang=js&"
export * from "./PrintSectionVoidsOnly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports